import * as React from 'react';
import { useSelector } from 'react-redux';
import { EFlatRoomCounts, TRoomsCountSelectorComponentProps } from 'shared/common/utils/types';
import { selectFormFields, selectEstimationTarget, selectIsNewbuilding } from '../../selectors';
import { useActions } from '../useActions';
import { ECurrentErrorField } from '../../types/formFields';
import { trackMyHomeRoomsCountClick } from '../tracking';
import { roomsCountSelectorOptions } from '../../constants/roomsCount';

/** Пропсы для фильтра выбора комнатности */
export const useRoomsCountSelectorProps = (): TRoomsCountSelectorComponentProps<EFlatRoomCounts> => {
  const {
    roomsCount,
    errorTooltip,
    userSetArea,
    userSetRoomsCount,
    flatAreasSuggest: { flatAreas },
  } = useSelector(selectFormFields);
  const estimationTarget = useSelector(selectEstimationTarget);
  const isNewbuilding = useSelector(selectIsNewbuilding);

  const { setRooms, setError, setArea, setUserRoomsCountFlag } = useActions();

  const errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.roomsCount ? errorTooltip.errorText : '';

  const onValueChange = React.useCallback(
    (value: EFlatRoomCounts) => {
      setRooms(value);

      if (!userSetRoomsCount) {
        setUserRoomsCountFlag(true);
      }

      if (errorMessage) {
        setError({
          currentErrorField: ECurrentErrorField.roomsCount,
          errorText: '',
        });
      }

      if (flatAreas) {
        const areaFound = flatAreas.find(item => item.roomsCount === value);
        if (areaFound && !userSetArea) {
          setArea(areaFound.area);
        }
      }

      trackMyHomeRoomsCountClick({
        estimationTarget,
        value,
        auto: false,
        isNewbuilding,
      });
    },
    [
      errorMessage,
      flatAreas,
      setArea,
      setError,
      setRooms,
      userSetArea,
      userSetRoomsCount,
      estimationTarget,
      isNewbuilding,
    ],
  );

  return {
    value: roomsCount || NaN,
    onValueChange,
    errorMessage,
    values: roomsCountSelectorOptions,
    placeholder: 'Комнат',
  };
};
